import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-ErrorPopup',
  templateUrl: './ErrorPopup.component.html',
  styleUrls: ['./ErrorPopup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorPopupComponent implements OnInit {

   message : string;
   
   constructor(public dialogRef: MatDialogRef<ErrorPopupComponent>) { }

   ngOnInit() {
   }

}
